import {stateListReports} from '@/modules/neodash/store/modules/reports/state';
import {GET_LIST_REPORTS, GET_PERIOD, LIST_REPORTS} from '@/modules/neodash/store/modules/reports/types';
import {Report} from '@/modules/neodash/model/types/interfaces/Report';
import {ReportEnum} from '@/modules/neodash/model/types/enums/reportEnum';
import {MonthYear, Period} from '@/modules/neodash/model/types/interfaces/Period';
import moment from 'moment';
import {store} from '@/store';
import {periodLimits} from '@/modules/neodash/model/constants/periodLimits';

export const getters = {
  [LIST_REPORTS]: (state): Report[] => {
    const result = state.lstReports;

    if (!result.length)
      store.dispatch(GET_LIST_REPORTS);

    return result;
  },

  [GET_PERIOD]: (state: stateListReports): (key: ReportEnum) => Period => {
    if (!state.lstReports.length)
      store.dispatch(GET_LIST_REPORTS);

    const getMonthYear = (date: string): MonthYear => {
      const finalDate = moment(date).toDate();
      return {
        month: finalDate.getMonth() + 1,
        year: finalDate.getFullYear()
      }
    };

    return key => {
      if (!state.lstReports.length)
        return periodLimits;

      const {limitPeriodInitial, limitPeriodFinal} = state.lstReports.findOrFirst(x => x.id === key);

      const [initial, final]: Array<MonthYear> =
          [limitPeriodInitial, limitPeriodFinal].map(getMonthYear);

      return {initial, final};
    }
  }
};
